<template>
  <div class="page flex-col">
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng884f9208ad222010878858fc8cb5e423234b83a1c9ddae1c598d3c8f9197f38f.png"
    />
    <div class="text-wrapper_1 flex-col">
      <span class="text_3">
        &nbsp;&nbsp;昌平是北京的新城和科教新区，是首都西北部生态屏障，是拥有6000年文明史、2000年建置史的昌盛平安之地，是坐拥明十三陵、居庸关两大世界文化遗产的文化旅游名区，是致力全国科技创新中心主平台建设、服务首都高质量发展的创新活力之城。
      </span>
      <span class="paragraph_1">
        <br />
        &nbsp;&nbsp;昌平区域面积1343.5平方公里，现辖8个街道、14个镇，2023年末，昌平区常住人口227.2万人，比上年末增加0.5万人，小幅上涨0.22%。其中，常住外来人口132.6万人，同比增加0.7万人，上涨0.53%，占常住人口的比重为58.4%。初步核算，2023年昌平区实现地区生产总值1424.6亿元，以不变价计算，比上年增长6.4%。其中，第一产业实现增加值6.8亿元，同比增长3.7%；第二产业实现增加值488.2亿元，同比增长7.8%；第三产业实现增加值929.6亿元，同比增长5.8%。改革开放40年来，坚持实施科教兴区战略、创新驱动发展战略，综合经济实力、城乡发展水平、社会民生福祉大幅提升，各项事业取得长足进步。特别是，2014年和2017年习近平总书记两次视察北京以后，紧抓京津冀协同发展、首都“四个中心”功能建设的历史机遇，以减量发展为基础、以创新发展为引领，经济社会发展正在发生一场深刻变革。
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />